import { render, staticRenderFns } from "./SectionComponent.vue?vue&type=template&id=ec0f9d4a&scoped=true&"
import script from "./SectionComponent.vue?vue&type=script&lang=js&"
export * from "./SectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SectionComponent.vue?vue&type=style&index=0&id=ec0f9d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0f9d4a",
  null
  
)

export default component.exports